import styled, { keyframes } from "styled-components";
import { theme } from "styles/theme";

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const Bone = styled.div<{ $width?: string }>`
  width: ${({ $width }) => $width ?? "80%"};
  height: 0.875rem;
  border-radius: ${theme.borderRadius.small};
  background: linear-gradient(
    90deg,
    ${theme.colors.lightGrey} 0%,
    ${theme.colors.bgLight} 50%,
    ${theme.colors.lightGrey} 100%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    background: ${theme.colors.lightGrey};
  }
`;

const Row = styled.tr`
  border-bottom: 1px solid ${theme.colors.borderLight};
`;

const Cell = styled.td`
  padding: 1rem 0.75rem;
  vertical-align: middle;
`;

interface SkeletonTableRowsProps {
  rows?: number;
  columns: number;
}

export function SkeletonTableRows({
  rows = 5,
  columns,
}: SkeletonTableRowsProps) {
  const widths = ["70%", "85%", "60%", "75%", "50%", "65%", "80%"];

  return (
    <>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <Row key={rowIndex} aria-hidden>
          {Array.from({ length: columns }, (_, colIndex) => (
            <Cell key={colIndex}>
              <Bone $width={widths[(rowIndex + colIndex) % widths.length]} />
            </Cell>
          ))}
        </Row>
      ))}
    </>
  );
}
